import { render, staticRenderFns } from "./ReferralsPoolIndexListing.vue?vue&type=template&id=2553e649"
import script from "./ReferralsPoolIndexListing.vue?vue&type=script&lang=js"
export * from "./ReferralsPoolIndexListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports